'use strict';

export const ACTIVE_TIMERS_COLLECTION = 'active-timers';
export const TIMER_ACTIVITIES_COLLECTION = 'timer-activities';



// WEBPACK FOOTER //
// ./src/js/timers/domain/config.js